import * as React from "react";
import { adopt } from "react-adopt";
import { Mutation, Query } from "react-apollo";
import addMovieToListUpdate from "src/cache/addMovieToList";
import deleteMovieFromListUpdate from "src/cache/deleteMovieFromList";
import CrewMember from "src/components/CrewMember";
import ExpandableList from "src/components/ExpandableList";
import ADD_MOVIE_TO_LIST from "src/mutations/addMovieToList";
import DELETE_MOVIE_FROM_LIST from "src/mutations/deleteMovieFromList";
import listMutationsOptimisticResponse from "src/mutations/listMutationOptimisticResponse";
import GET_MOVIE from "src/queries/getMovie";
import MovieCard from "../components/MovieCard";
import "./Movie.css";
import Shell from "./Shell";

export class MovieContainer extends React.Component<any, any> {
  public render() {
    return (
      <Shell>
        {({ mutations, queries }) => (
          <MovieComposed
            match={this.props.match}
            userProfile={
              queries.getUserProfile.data &&
              queries.getUserProfile.data.userProfile
            }
          />
        )}
      </Shell>
    );
  }
}

const Movie = ({
  addMovieToList,
  deleteMovieFromList,
  getMovie,
  userProfile
}) => {
  let movie;
  if (getMovie && getMovie.data) {
    movie = getMovie.data.movie;
  }
  return (
    <div className="movie-page page">
      <div className="ui grid">
        <div className="ten centered wide column">
          {movie && (
            <div>
              <MovieCard
                addMovieToList={addMovieToList}
                deleteMovieFromList={deleteMovieFromList}
                listMutationsOptimisticResponse={
                  listMutationsOptimisticResponse
                }
                key={movie.id}
                directors={movie.directors}
                movieId={movie.id}
                poster={movie.poster}
                releaseDate={
                  movie.displayReleaseDate && movie.displayReleaseDate.date
                }
                title={movie.title}
                runtime={movie.runtime}
                userProfile={userProfile}
              />
              <h4>Overview</h4>
              <p>{movie.overview}</p>
              <ExpandableList items={movie.directors} title="Directors">
                {d => (
                  <CrewMember
                    id={d.id}
                    key={d.id}
                    profilePictureUrl={d.profile_path}
                    primaryText={d.name}
                    secondaryText=""
                  />
                )}
              </ExpandableList>
              <ExpandableList items={movie.cast} title="Cast">
                {c => (
                  <CrewMember
                    id={c.id}
                    key={c.id}
                    profilePictureUrl={c.profile_path}
                    primaryText={c.name}
                    secondaryText={c.character}
                  />
                )}
              </ExpandableList>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Compose = adopt({
  addMovieToList: ({ render, userProfile }) => (
    <Mutation
      mutation={ADD_MOVIE_TO_LIST}
      update={addMovieToListUpdate({ userProfile }) as any}
    >
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
  deleteMovieFromList: ({ render, userProfile }) => (
    <Mutation
      mutation={DELETE_MOVIE_FROM_LIST}
      update={deleteMovieFromListUpdate({ userProfile }) as any}
    >
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
  getMovie: ({ render, match }) => (
    <Query query={GET_MOVIE} variables={{ id: Number(match.params.movieId) }}>
      {render}
    </Query>
  )
});

const MovieComposed = ({ match, userProfile }) => (
  <Compose match={match} userProfile={userProfile}>
    {({ addMovieToList, deleteMovieFromList, getMovie }) => (
      <Movie
        addMovieToList={addMovieToList}
        deleteMovieFromList={deleteMovieFromList}
        getMovie={getMovie}
        userProfile={userProfile}
      />
    )}
  </Compose>
);

export default MovieContainer;



// WEBPACK FOOTER //
// ./src/containers/Movie.tsx